import React from "react";
import type { ReactNode } from "react";
import { createContext, useState } from "react";

import { Feedback } from "../../api";

type FeedbackProviderProps = {
    children: ReactNode;
};

type FeedbackContextType = {
    feedback: Map<string, Feedback>;
    setFeedback: React.Dispatch<React.SetStateAction<Map<string, Feedback>>>;
};

export const FeedbackState = createContext<FeedbackContextType | undefined>(undefined);

export const FeedbackProvider: React.FC<FeedbackProviderProps> = ({ children }) => {
    const [feedback, setFeedback] = useState<Map<string, Feedback>>(new Map());

    return <FeedbackState.Provider value={{ feedback, setFeedback }}>{children}</FeedbackState.Provider>;
};
